import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type AddUserSuccessResponseType = { message: string };
export type CreateUserPayload = {
	email: string;
	firstName: string;
	lastName: string;
	groups: string[];
	organizations: string[];
	password?: string;
};

async function addUser(payload: CreateUserPayload): Promise<AddUserSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.USERS.INDEX}`, payload);
	return getResponse<AddUserSuccessResponseType>(response.data);
}

export function addUserOptions() {
	return mutationOptions({
		mutationFn: (payload: CreateUserPayload) => addUser(payload),
		onSuccess: async (data) => {
			console.log('User added successfully:', data);
			toast.success(t('admin.toast.userAdded'));
			await queryClient.invalidateQueries({ queryKey: ['users'] });
		},
		onError: (error) => toastApiError(error),
	});
}
